<template>
  <div class="quick-menu" v-if="isAllowedPage">
    <ul>
      <li class="on">
        <router-link :to="{ name: ROUTE_NAME.Reservation }">
          <img src="@assets/img/ic_quick_01.svg" alt="예약" />예약
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: ROUTE_NAME.ReservationStatus }">
          <img src="@assets/img/ic_quick_02.svg" alt="예약확인" />예약확인
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: ROUTE_NAME.News }">
          <img src="@assets/img/ic_quick_03.svg" alt="공지사항" />공지사항
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script setup lang="ts">
import { ref, watch } from 'vue';
import { RouteLocationNormalized, useRouter } from 'vue-router';
import { ROUTE_NAME } from '@constants';

const isAllowedPage = ref(false);
const { currentRoute } = useRouter();
const isSigninOpen = ref(false);

const exceptRouteList = [ROUTE_NAME.Main];

watch(currentRoute, (to: RouteLocationNormalized) => {
  isSigninOpen.value = false;
  const isExceptRoute = !exceptRouteList.includes(to.name as ROUTE_NAME);
  isAllowedPage.value = !isExceptRoute;
});
</script>

<style scoped lang="scss">
// PC
.quick-menu {
  position: fixed;
  top: 50%;
  right: 0;
  width: 90px;
  transform: translateY(-50%);
  background-color: rgba(34, 34, 34, 0.9);
  z-index: 1;
  border-radius: 16px 0 0 16px;
  overflow: hidden;
}

.quick-menu ul li {
  position: relative;
  height: 100px;
  font-size: 14px;
  color: #fff;
  border-bottom: solid 1px rgba(255, 255, 255, 0.24);
}

.quick-menu ul li:last-child {
  border-bottom: 0;
}

.quick-menu ul li.on {
  background-color: var(--color-main);
}

.quick-menu ul li a {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 10px 0;
}

@media (max-width: 1280px) {
  .quick-menu {
    display: none;
  }
}
</style>
